import React, { forwardRef } from 'react'

import { PseudoBox, PseudoBoxProps } from '../PseudoBox'
import { Icon } from '../Icon'

const baseProps = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 0.2s',
  flex: '0 0 auto',
  borderRadius: 'full',
  outline: 0,
  _hover: { bg: 'blackAlpha.100' },
  _active: { bg: 'blackAlpha.200' },
  _disabled: {
    cursor: 'not-allowed',
  },
  _focus: {
    boxShadow: 'outline',
  },
}

const sizes = {
  lg: {
    button: '40px',
    icon: '24px',
  },
  md: {
    button: '32px',
    icon: '20px',
  },
  sm: {
    button: '24px',
    icon: '16px',
  },
}

export interface CloseButtonProps extends PseudoBoxProps {
  size?: 'sm' | 'md' | 'lg'
  type?: string
  isDisabled?: boolean
  isRound?: boolean
}

export const CloseButton = forwardRef(
  (
    {
      size = 'md',
      type = 'button',
      isDisabled,
      color = 'pink.500',
      'aria-label': ariaLabel = 'Close',
      ...restProps
    }: CloseButtonProps,
    ref,
  ) => {
    const buttonSize = sizes[size]?.button
    const iconSize = sizes[size]?.icon

    // TS workarounds
    const _props = { type, disabled: isDisabled }

    return (
      <PseudoBox
        as="button"
        aria-disabled={isDisabled}
        aria-label={ariaLabel}
        size={buttonSize}
        ref={ref}
        {..._props}
        {...baseProps}
        {...restProps}
      >
        <Icon color={color} focusable={false} name="close_outline" aria-hidden size={iconSize} />
      </PseudoBox>
    )
  },
)

export default CloseButton
